import React, { useEffect, useRef } from 'react'
import ReactDOM from 'react-dom'
import styles from '../Utils/Modal.module.css'
import SlideUpWrapper from './Transitions/SlideUpWrapper'

export default function ReactPortalModal({ isOpen, title, blockOutsideClick = false, children, onClose, showClose=true }) {
    const dropdownRef = useRef(null);
    const handleClickOutside = (event) => {
        if (blockOutsideClick) return
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            onClose(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    useEffect(() => {
        return function () {
            document.removeEventListener('keydown', handleKeyPress)
            let body = document.getElementsByTagName("body")[0]
            body.classList.remove('modal-open')
        }
    }, [isOpen])

    function handleKeyPress(e) {
        if (e.keyCode == 27)
            onClose(false)
    }



    if (!isOpen)
        return null
    return ReactDOM.createPortal(
        <>
            <div className={styles.PopupBackground} onClick={(e) => blockOutsideClick ? {} : onClose(false)}>
                <div style={{minWidth:416, maxWidth:1000}}>
                    <SlideUpWrapper>
                        <div className={styles.Popup} ref={dropdownRef}>
                            <div className={styles.popupHeader}>
                                <div className={styles.title}>
                                    {title}
                                </div>
                                {showClose&&<div className={styles.close} onClick={() => onClose(false)} title='Close'><img src='/closeBar.svg' /></div>}
                            </div>
                            <hr />
                            {children}
                        </div>
                    </SlideUpWrapper>
                </div>
            </div>

        </>
        , document.getElementById('modal-root')
    )
}